/*
 * @format
 * @flow
 */

import {
    LOAD_GAMES_START,
    LOAD_GAMES_ERROR,
    LOAD_GAMES_COMPLETE,
    DISPLAY_NEXT_IN_FULLSCREEN,
} from '../actions/games';

const initialState = {
    games: null,
    error: null,
    nextInFullScreen: undefined, //used to display a game in fullscreen when opening from home
};

export default function gamesReducer(state = initialState, action) {
    switch (action.type) {
        case LOAD_GAMES_START: {
            return initialState;
        }
        case LOAD_GAMES_COMPLETE: {
            return {...state, games: action.games};
        }
        case LOAD_GAMES_ERROR: {
            return {...state, error: action.error};
        }
        case DISPLAY_NEXT_IN_FULLSCREEN: {
            return {...state, nextInFullScreen: action.nextInFullScreen};
        }
        default: {
            return state;
        }
    }
}
